import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// import logo from './logo.svg';
import './App.css';
import Home from './Scenes/Home/Home';
import Menu from './containers/Menu/Menu';
import Technology from './Scenes/Technology/Technology';
import Customers from './Scenes/Customers/Customers';
import Impact from './Scenes/Impact/Impact';
import Solution from './Scenes/Solution/Solution';
import Contact from './Scenes/Contact/Contact';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Menu />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/technology" component={Technology} />
          <Route path="/customers" component={Customers} />
          <Route path="/impact" component={Impact} />
          <Route path="/solution" component={Solution} />
          <Route path="/contact" component={Contact} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;